import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ManipulationsToolbarStore } from 'src/app/store/manipulations-toolbar-store';
import { ApprovalStore } from '../../store/approval-store';
import {
  ApprovalSortBy,
  SortDirection,
} from '../../../../models/approval.model';

@Component({
    selector: 'que-approvals-list-header',
    imports: [CommonModule, TranslateDirective, TranslatePipe],
    templateUrl: './approvals-list-header.component.html',
    styleUrls: ['./approvals-list-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApprovalsListHeaderComponent {
  #manipulationsToolbarStore = inject(ManipulationsToolbarStore);
  #approvalStore = inject(ApprovalStore);

  pendingApprovalTab$ = toSignal(this.#manipulationsToolbarStore.pendingApprovalTab$);
  afterApprovalTab$ = toSignal(this.#manipulationsToolbarStore.afterApprovalTab$);
  downloadRecordsTab$ = toSignal(this.#manipulationsToolbarStore.downloadRecordsTab$);
    readonly ApprovalSortBy = ApprovalSortBy;
  readonly SortDirection = SortDirection;

  @Input() sortBy: ApprovalSortBy = ApprovalSortBy.SentDate;
  @Input() sortDirection: SortDirection = SortDirection.Desc;

  @Output() sortChange = new EventEmitter<ApprovalSortBy>();
  requestSort(column: ApprovalSortBy): void {
    this.sortChange.emit(column);
  }

  handleSpaceKey(
    event: Event,
    column: ApprovalSortBy
  ): void {
    event.preventDefault();
    this.requestSort(column);
  }
   approvals$ = toSignal(this.#approvalStore.approvals$);
  selectedIds$ = toSignal(this.#approvalStore.selectedIds$);

  get isAllSelected(): boolean {
    const ids = this.approvals$()?.result?.map((a) => a.id) ?? [];
    return ids.length > 0 && ids.every((id) => !!this.selectedIds$()?.[id]);
  }

  toggleSelectAll(): void {
    const ids = this.approvals$()?.result?.map((a) => a.id) ?? [];
    this.#approvalStore.toggleSelectAll(ids);
  }

  expandedIds$ = toSignal(this.#approvalStore.expandedIds$);

  get isAllExpanded(): boolean {
    const approvals = this.approvals$()?.result ?? [];
    return approvals.length > 0 && approvals.every((a) => !!this.expandedIds$()?.[a.id]);
  }

  toggleExpandAll(): void {
    this.#approvalStore.toggleExpandAll(this.approvals$()?.result ?? []);
  }
}
